import { render, staticRenderFns } from "./PolizaSaludMMT.vue?vue&type=template&id=3adaa5f0&scoped=true&"
import script from "./PolizaSaludMMT.vue?vue&type=script&lang=js&"
export * from "./PolizaSaludMMT.vue?vue&type=script&lang=js&"
import style0 from "./PolizaSaludMMT.vue?vue&type=style&index=0&id=3adaa5f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adaa5f0",
  null
  
)

export default component.exports